/**
 * 笔记菜单命令事件管理器（跨组件命令路由）
 *
 * 背景：移动端 CRDT 编辑模式下，Header 右侧的"三个点"菜单需要触发当前笔记的
 * 分享/历史记录/导出/删除等功能。这些功能的实现依赖编辑器面板内部状态
 * （编辑器实例、对话框状态、笔记内容），Header 无法也不应重复实现。
 *
 * 模式：与 deleteNoteEventManager 完全一致的注册/触发模式——面板挂载时按
 * noteId 注册回调（面板是各功能的唯一实现方），Header 菜单点击时按
 * activeNoteId 触发。命令直达目标面板，不经 Redux（无状态、零重渲染）。
 */

export type NoteMenuAction =
  | 'share'
  | 'history'
  | 'find-in-note'
  | 'export-docx'
  | 'export-pdf'
  | 'export-markdown'
  | 'delete'

type NoteMenuCallback = (action: NoteMenuAction) => void

class NoteMenuEventManager {
  private callbacks: Map<string, NoteMenuCallback> = new Map()

  registerCallback(noteId: string, callback: NoteMenuCallback) {
    this.callbacks.set(noteId, callback)
  }

  unregisterCallback(noteId: string) {
    this.callbacks.delete(noteId)
  }

  triggerAction(noteId: string, action: NoteMenuAction) {
    const callback = this.callbacks.get(noteId)
    if (callback) {
      callback(action)
    }
  }
}

export const noteMenuEventManager = new NoteMenuEventManager()
